interface Props {
  totals: {
    totalAmount: number;
    totalGst: number;
    grandTotal: number;
  };
}

export default function InvoiceTotalsSection({ totals }: Props) {
  return (
    <div className="flex flex-col items-end gap-1">
      <p className="text-sm text-neutral-600">
        Total Amount: ₹{totals.totalAmount.toFixed(2)}
      </p>
      <p className="text-sm text-neutral-600">
        Total GST: ₹{totals.totalGst.toFixed(2)}
      </p>
      <p className="font-semibold text-primary-600">
        Grand Total: ₹{totals.grandTotal.toFixed(2)}
      </p>
    </div>
  );
}
